import React from "react";
import PropTypes from "prop-types";
import "../css/CompanyTeam.css";
import Image from "./ImageElement";

/**
 * CompanyTeam component
 */
class CompanyTeam extends React.Component {
  static displayName = "CompanyTeam";
  static propTypes = {
    className: PropTypes.string,
    team: PropTypes.node,
  };
  static defaultProps = {
    team: [],
  };

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "CompanyTeam";
  }

  /**
   * @override
   */
  render() {
    return (
      <div className={`${this.className} ${this.props.className || ""}`}>
        {this.props.team.map((employee) => {
          const image = employee.profile();
          return (
            <div className={`${this.className}__employee`} key={employee.ID}>
              <div className={`${this.className}__profile`}>
                <Image
                  src={image[`${this.props.screen}_src`]}
                  alt={image.alt}
                />
              </div>
              <div
                className={`${this.className}__name`}
                dangerouslySetInnerHTML={{ __html: employee.fullname() }}
              />
              <div
                className={`${this.className}__job`}
                dangerouslySetInnerHTML={{ __html: employee.JobTitle }}
              />
            </div>
          );
        })}
      </div>
    );
  }
}

export default CompanyTeam;



// WEBPACK FOOTER //
// ./src/components/CompanyTeam.js